import { createTrignometryOperator } from "./_internal";
const $tan = createTrignometryOperator(Math.tan);
export {
  $tan
};
